<template>
  <div class="formFilter">
    <b-row>
      <b-col md="8" class="mb-3">
        <b-form-input
          placeholder="Buscar por nombre y apellido"
          type="search"
          v-model="requestSend.criterio"
        >
        
        </b-form-input>
      </b-col>
       <b-col md="4" class="mb-3">
          <b-form-select v-model="requestSend.vacante">
               <b-form-select-option
              v-for="vacant in listVacant"
              :key="vacant.id"
              :value="vacant.nombre"
            >
            <template v-if="vacant.nombre !== ''">
            {{ vacant.nombre}}
            </template>
             
               <template v-else>
            Todas las vacantes 
            </template>
              
              </b-form-select-option>

          </b-form-select>
       </b-col>
    </b-row>
    <b-row>
      <b-col md="4" class="mb-2">
        <b-form-group label="Fecha desde">
          <b-form-datepicker
            locale="es"
            placeholder="Fecha desde"
            type="date"
            v-model="requestSend.desde"
            :max="requestSend.hasta"
          >
          </b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col md="4" class="mb-2">
        <b-form-group label="Fecha hasta">
          <b-form-datepicker
            locale="es"
            type="date"
            v-model="requestSend.hasta"
            placeholder="Fecha hasta"
            :min="requestSend.desde"
          >
          </b-form-datepicker>
        </b-form-group>
      </b-col>
      <b-col md="4" class="mb-2 container-btn">
        <b-form-group label="Estatus" class="w-100">
          <b-form-select v-model="requestSend.estatus">
            <b-form-select-option
              v-for="estatus in ESTATUS"
              :key="estatus.id"
              :value="estatus.value"
            >
              {{ estatus.text }}</b-form-select-option
            >
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapState } from "vuex";
import { ESTATUS_SOLICITUD } from "../utils/constants";
import moment from "moment"
export default {
  data() {
    return {
      requestSend: {
        criterio: "",
        desde:  moment(new Date()).add(-20, 'day').format(),
        hasta: new Date(),
        estatus: "",
        vacante:""
      },
      listVacant: [{ nombre: "" }],
      ESTATUS: ESTATUS_SOLICITUD,
    };
  },
  async mounted() {
   this.requestSend = this.request
    await this.getListVacant();
    await this.getListRequest();
  },
  methods: {
    async getListRequest() {
      await this.$store.dispatch({
        type: "applyEmployer/getListRequests",
        data: this.request,
      });
    },
    async getListVacant() {
      const resp = await this.$store.dispatch({
        type: "vacant/getListVacantAvailable",
      });

      this.listVacant.push(...resp);
    },
  },
  computed: {
    ...mapState({
      request: (state) => state.applyEmployer.request,
    }),
  },

  watch: {
       "requestSend.vacante": {
      async handler() {
        this.$store.commit(
          "applyEmployer/SET_VACANTE",
          this.requestSend.vacante
        );
        await this.getListRequest();
      },
    },
    "requestSend.criterio": {
      async handler() {
        this.$store.commit(
          "applyEmployer/SET_FILTER",
          this.requestSend.criterio
        );
        await this.getListRequest();
      },
    },
    "requestSend.desde": {
      async handler() {
        if (this.requestSend.hasta < this.requestSend.desde) {
          this.requestSend.desde = this.requestSend.desde.setDate(
            this.requestSend.hasta.getDate() - 10
          );
        }
        this.$store.commit(
          "applyEmployer/SET_FECHA_DESDE",
          this.requestSend.desde
        );
        await this.getListRequest();
      },
    },
    "requestSend.hasta": {
      async handler() {
        this.$store.commit(
          "applyEmployer/SET_FECHA_HASTA",
          this.requestSend.hasta
        );
        await this.getListRequest();
      },
    },
    "requestSend.estatus": {
      async handler() {
        this.$store.commit(
          "applyEmployer/SET_ESTADO",
          this.requestSend.estatus
        );
        await this.getListRequest();
      },
    },
  },
};
</script>
<style scoped>
.container-btn {
  display: flex;
  justify-content: center;
}
</style>
